// Capture only the browser's IANA timezone name before replacing its Intl
// implementation. Offset rules will come from the application's bundled data.
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default browserTimezone;
